/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".layer-item[_ngcontent-%COMP%]{position:relative;padding:5px;box-sizing:border-box;cursor:pointer}.layer-item[_ngcontent-%COMP%]:hover{background:#f3f3f3;color:#000}.layer-item[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{display:inline-block}.layer-item[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{position:absolute;right:10px;top:8px;pointer-events:none}\n/*# sourceMappingURL=layer-select-modal.component.css.map*/"];
export { styles as styles };
